import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { GiftObligationsPage } from "@/features/finance-reports";

export const Route = createFileRoute("/reports/gift-obligations")({
  component: GiftObligationsRoute,
});

function GiftObligationsRoute() {
  return (
    <AdminDashboardShell>
      <GiftObligationsPage />
    </AdminDashboardShell>
  );
}
